export default __webpack_public_path__ + "static/media/error.78725617.ogg";